const mainHeader = document.getElementById('main-header');
let previousScrollPosition = window.scrollY;

window.addEventListener('scroll', function () {
    let currentScrollPosition = window.scrollY;
    let headerHeight = mainHeader.offsetHeight;
    let hasOpenSubmenu = mainHeader.querySelector('.main-menu-submenu.open') !== null;
    
    if (currentScrollPosition >= headerHeight && !hasOpenSubmenu) {
        if (currentScrollPosition > previousScrollPosition) {
            // Scrolling down
            mainHeader.classList.add('hidden');
        } else {
            // Scrolling up
            mainHeader.classList.remove('hidden');
        }
    }

    if (currentScrollPosition > headerHeight * 2) {
        this.setTimeout(() => {
            mainHeader.classList.remove('transparent');
        }, 300); // Delay to prevent flickering
    } else {
        this.setTimeout(() => {
            mainHeader.classList.add('transparent');
        }, 300); 
    }

    previousScrollPosition = currentScrollPosition;
});